import React, { forwardRef, Fragment } from 'react';
import { ListItem } from '../../components/list-item';
import { IconButton } from './themed/migration';
/**
 * __User action__
 *
 * A user action button for the top navigation. Used for adding custom actions that are not already provided.
 *
 * For common actions, like `Notifications`, `Help`, `Profile`, `Settings`, use the provided components as appropriate.
 */
export var UserAction = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var label = _ref.label,
    icon = _ref.icon,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    isSelected = _ref.isSelected,
    testId = _ref.testId,
    interactionName = _ref.interactionName,
    ariaControls = _ref['aria-controls'],
    ariaExpanded = _ref['aria-expanded'],
    ariaHasPopup = _ref['aria-haspopup'],
    _ref$isListItem = _ref.isListItem,
    isListItem = _ref$isListItem === void 0 ? true : _ref$isListItem;
  var Wrapper = isListItem ? ListItem : Fragment;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(IconButton, {
    ref: forwardedRef,
    icon: icon,
    label: label,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    appearance: "subtle",
    isSelected: isSelected,
    isTooltipDisabled: false,
    testId: testId,
    interactionName: interactionName,
    "aria-controls": ariaControls,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": ariaHasPopup
  }));
});